export const EVENT_DISPLAY_NAME_SCHEMA_URL = 'https://heygirl.cutestperson.com/assets/public/schemas/eventDisplayNameSchemaV1_0_0.json' as const;
export const EVENT_DISPLAY_NAME_COMPONENT_TYPE = 'EventDisplayName' as const;
